 <template>
    <transition name="message" @after-leave="afterLeave">
        <div
            class="base-message"
            v-show="visible"
            :class="className"
            @mouseenter="clearTimer"
            @mouseleave="startTimer"
            role="alert"
            tabindex="0">
            <div class="base-message-icon" aria-hidden="true">
                <span v-html="iconObj[type]"></span>
            </div>
            <div class="base-message-content">{{ message }}</div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            require: true
        },
        message: {
            type: String,
            default: 'Default Info'
        },
        duration: {
            type: [Number, String],
            default: 3000
        }
    },
    name: 'CommonMessage',
    data() {
        return {
            top: null,
            visible: false,
            closed: false,
            timer: null,
            iconObj: {
                info: 'i',
                error: '!',
                success: '&#10004;'
            },
        }
    },
    computed: {
        className() {
            let temClassName = 'base-top' + (this.top || '');
            temClassName = temClassName + ' base-' + this.type;
            return temClassName;
        }
    },
    watch: {
        closed(newVal) {
            if (newVal) {
                this.visible = false;
            }
        }
    },
    methods: {
        afterLeave() {
            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        },

        close() {
            this.closed = true;
            if(this.onClose && typeof this.onClose === 'function') {
                this.onClose(this.top, this);
            }
        },

        clearTimer() {
            clearTimeout(this.timer);
        },

        startTimer() {
            if (this.duration > 0) {
                this.timer = setTimeout(() => {
                    if (!this.closed) {
                        this.close();
                    }
                }, this.duration);
            }
        },
        keydown(e) {
            if (e.keyCode === 27) { // esc turn off message
                if (!this.closed) {
                    this.close();
                }
            }
        },
        show(type, message) {
            this.type = type;
            this.message = message;
            this.mounted();
        },
    },

    mounted() {
        this.startTimer();
        document.addEventListener('keydown', this.keydown);
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.keydown);
    }
}
</script>

<style lang="scss">
.base-message {
    width: 380px;
    height: fit-content;
    position: fixed;
    top: -66px;
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.3s linear;
    box-sizing: border-box;
    padding: 12px 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    background-color: #ffffff;
    .base-message-icon {
        color: var(--base-text-color);
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        border-radius: 50%;
        margin-right: 18px;
        font-weight: bold;
    }

    .base-message-content {
        width: calc(100% - 20px);
        color: var(--base-text-color);
        font-weight: bold;
        font-size: 14px;
    }
    &.base-error {
        border-left: 4px solid var(--base-error-color);
        color: var(--base-error-color);
        .base-message-icon {
            background-color: var(--base-error-color);
            color: #fff;
        }
    }

    &.base-info {
        border-left: 4px solid var(--base-primary-color);
        color: var(--base-primary-color);
        .base-message-icon {
            background-color: var(--base-primary-color);
            color: #fff;
        }
    }

    &.base-success {
        border-left: 4px solid var(--base-success-color);
        color: var(--base-success-color);
        .base-message-icon {
            background-color: var(--base-success-color);
            color: #fff;
        }
    }
}
.base-message.base-top20 {
    top: 20px;
}
.base-message.base-top86 {
    top: 86px;
}
.base-message.base-top152 {
    top: 152px;
}
</style>